import { useContext, useEffect, useState } from 'react';

import { postIncodeVerificationUrl, postSaleVerifications } from 'PrivateApis';

import { ConfigContext } from 'Context/config';

import { APIResponseStatus } from 'Services/api.types';

import { useVehicleCollectionSub } from 'Containers/app/vehicleCollection/hooks/useVehicleCollectionSub';

import { authorizationHeader } from '../../../vehicleCollection/services/apiClient';

type IncodeVerificationUrl = Partial<{
  authToken: string;
  dpEnquiryId: number;
  onError: () => void;
  onSuccess: () => void;
}>;

export const useIncodeVerificationUrl = ({
  authToken,
  dpEnquiryId,
  onError,
  onSuccess,
}: IncodeVerificationUrl) => {
  const { collectionDetails, offer, offerStatus } = useVehicleCollectionSub();
  const { configState: { featureFlags } } = useContext(ConfigContext);
  const [loading, setLoading] = useState<boolean>(true);

  const saleId = collectionDetails?.data?.saleId;
  const isOnFinance = !!offer?.data?.finance?.isVehicleOnFinance;
  const useV2 = !!featureFlags?.useV2SaleVerifications;

  useEffect(() => {
    const abortController = new AbortController();

    if (offerStatus !== APIResponseStatus.SUCCESS) {
      return () => {};
    }

    if (useV2 && collectionDetails !== undefined && collectionDetails?.loading !== false) {
      return () => {};
    }

    if (!authToken || !dpEnquiryId) {
      setLoading(false);
      return onError?.();
    }

    const request = useV2
      ? postSaleVerifications(authorizationHeader(authToken), { enquiryId: dpEnquiryId, saleId }, abortController)
      : postIncodeVerificationUrl(dpEnquiryId, authorizationHeader(authToken), { isOnFinance }, abortController);

    request
      .then(() => onSuccess?.())
      .catch((err) => {
        window?.Sentry?.captureException?.(err);
        onError?.();
      })
      .finally(() => setLoading(false));

    return () => {
      abortController?.abort();
    };
  }, [authToken, collectionDetails?.loading, dpEnquiryId, isOnFinance, onError, onSuccess, offerStatus, saleId, useV2]);

  return {
    loading,
  };
};
